export const AFASTAMENTO_DASHBOARD_KPIS = {
  afastamentosAtivos: { value: 2458, trend: '▲ 8,6%', trendDir: 'up', trendColor: 'green', comparison: 'vs. abr/2025' },
  feriasAndamento: { value: 1128, trend: '▲ 12,4%', trendDir: 'up', trendColor: 'green', comparison: 'vs. abr/2025' },
  ltspAtivas: { value: 842, trend: '▲ 5,7%', trendDir: 'up', trendColor: 'green', comparison: 'vs. abr/2025' },
  ltspfAtivas: { value: 112, trend: '▼ -2,6%', trendDir: 'down', trendColor: 'red', comparison: 'vs. abr/2025' },
  agregados: { value: 356, trend: '▲ 3,1%', trendDir: 'up', trendColor: 'green', comparison: 'vs. abr/2025' },
  mobilizados: { value: 188, trend: '▲ 7,3%', trendDir: 'up', trendColor: 'green', comparison: 'vs. abr/2025' },
  homologacoesPendentes: { value: 67, trend: '▼ -15,2%', trendDir: 'down', trendColor: 'red', comparison: 'vs. abr/2025' },
  solicitacoesPendentes: { value: 231, trend: '▲ 9,8%', trendDir: 'up', trendColor: 'green', comparison: 'vs. abr/2025' }
};

export const AFASTAMENTO_POR_TIPO = [
  { name: 'Férias', count: 1128, pct: 45.9, color: '#3b82f6' },
  { name: 'Saúde', count: 624, pct: 25.4, color: '#10b981' },
  { name: 'Licenças', count: 373, pct: 15.2, color: '#8b5cf6' },
  { name: 'Agregação', count: 175, pct: 7.1, color: '#f59e0b' },
  { name: 'Mobilização', count: 158, pct: 6.4, color: '#ef4444' }
];

export const AFASTAMENTO_EVOLUCAO_MENSAL = [
  { month: 'Jan', value: 1987 },
  { month: 'Fev', value: 2105 },
  { month: 'Mar', value: 2256 },
  { month: 'Abr', value: 2266 },
  { month: 'Mai', value: 2458 }
];

export const AFASTAMENTO_DISTRIBUICAO_UNIDADE = [
  { name: 'PM-1 (CG)', value: 312 },
  { name: 'PM-2 (CPO)', value: 284 },
  { name: 'PM-3 (CCO)', value: 276 },
  { name: 'PM-4 (CBM)', value: 245 },
  { name: 'PM-5 (CPT)', value: 198 },
  { name: 'PM-6 (CSM)', value: 178 },
  { name: 'PM-7 (CCO)', value: 165 },
  { name: 'PM-8 (DGP)', value: 152 },
  { name: 'PM-9 (CCS)', value: 131 },
  { name: 'PM-10 (CROP)', value: 115 }
];

export const AFASTAMENTO_EFETIVO_DISPONIVEL = {
  labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai'],
  disponivel: [12780, 12590, 12410, 12230, 12015],
  indisponivel: [1987, 2105, 2256, 2266, 2458]
};

export const AFASTAMENTO_SAUDE_FERIAS = {
  labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai'],
  saude: [600, 620, 630, 610, 624],
  ferias: [850, 920, 1050, 1100, 1128],
  licencas: [300, 310, 320, 330, 373]
};

export const AFASTAMENTO_PROXIMOS_VENCIMENTOS = [
  { tipo: 'Férias', registros: 156, data: 'Até 30/05/2025', icon: 'forest', color: '#10b981' },
  { tipo: 'LTSP', registros: 87, data: 'Até 28/05/2025', icon: 'favorite', color: '#8b5cf6' },
  { tipo: 'LTIP', registros: 23, data: 'Até 31/05/2025', icon: 'person_outline', color: '#f59e0b' },
  { tipo: 'Licença Especial', registros: 64, data: 'Até 15/06/2025', icon: 'assignment', color: '#3b82f6' }
];

export const AFASTAMENTO_ALERTAS_CRITICOS = [
  { titulo: 'Sobreposição de Férias', descricao: '32 ocorrências detectadas', valor: 32, icon: 'warning', color: 'red' },
  { titulo: 'Conflitos de Escala', descricao: '18 ocorrências detectadas', valor: 18, icon: 'warning', color: 'orange' },
  { titulo: 'Homologações Atrasadas', descricao: '67 processos', valor: 67, icon: 'info', color: 'yellow' },
  { titulo: 'Documentos Pendentes', descricao: '112 registros', valor: 112, icon: 'info', color: 'blue' }
];

export const AFASTAMENTO_ULTIMAS_HOMOLOGACOES = [
  { titulo: 'Férias - Maj QOPM 1234567', unidade: 'PM-1 (CG)', tempo: 'Há 2h', color: 'green' },
  { titulo: 'LTSP - Cap QOPM 2345678', unidade: 'PM-2 (CPO)', tempo: 'Há 3h', color: 'green' },
  { titulo: 'Licença Especial - 1º Ten QOPM 3456789', unidade: 'PM-3 (CCO)', tempo: 'Há 5h', color: 'green' },
  { titulo: 'LTIP - Maj QOPM 4567890', unidade: 'PM-4 (CBM)', tempo: 'Há 6h', color: 'green' },
  { titulo: 'Férias - 2º Sgt QPPMC 5678901', unidade: 'PM-5 (CPT)', tempo: 'Há 8h', color: 'green' }
];

export const PCF_KPIS = {
  totalPMAtivos: { value: 16842, sub: '100% do efetivo' },
  feriasPrevistas: { value: 15105, sub: '89,69% do efetivo', iconColor: 'green' },
  feriasAlocadas: { value: 13642, sub: '90,31% do previsto', iconColor: 'purple' },
  conflitosIdentificados: { value: 128, sub: '0,76% do efetivo', iconColor: 'red' },
  capacidadeMensal: { value: 1403, sub: 'PM por mês', iconColor: 'orange' },
  disponivelAlocar: { value: 1463, sub: '9,69% do previsto', iconColor: 'teal' }
};

export const PCF_TREE = [
  {
    name: 'Cmt Geral (Comando Geral da PMDF)',
    expanded: true,
    children: [
      { name: 'EM (Estado Maior)' },
      { name: 'GCG (Gabinete do Comandante Geral)' },
      { name: 'CI (Centro de Inteligência)' },
      { name: 'CCS (Centro de Comunicação Social)' },
      { name: 'SRI (Secretaria de Relações Institucionais)' },
      { name: 'CETI (Centro de Tecnologia e Inovação)' },
      {
        name: 'SubCmtGeral (Subcomandante-Geral)',
        expanded: true,
        children: [
          {
            name: 'DSAP (Departamento de Saúde e Assistência ao Pessoal)',
            children: [
              {
                name: 'DAS (Diretoria de Assistência à Saúde)',
                children: [
                  { name: 'CAPS (Centro de Assistência Psicológica e Social)' },
                  { name: 'CCF (Centro de Capacitação Física)' },
                  { name: 'CMed (Centro Médico)' },
                  { name: 'CPSO (Centro de Perícias e Saúde Ocupacional)' },
                  { name: 'CASO (Centro de Assistência Social)' }
                ]
              },
              {
                name: 'DAO (Diretoria de Assistência Odontológica)',
                children: [
                  { name: 'CAO (Centro de Assistência Odontológica)' },
                  { name: 'CO (Centro Odontológico)' }
                ]
              },
              { name: 'DPGC (Diretoria de Planejamento e Gestão de Contratos)' },
              { name: 'DEOF (Diretoria de Execução Orçamentária e Financeira)' },
              { name: 'CPQV (Centro de Promoção da Qualidade de Vida)' }
            ]
          },
          {
            name: 'DCC (Departamento de Controle e Correição)',
            children: [
              { name: 'CA (Corregedoria Adjunta)' },
              { name: 'AUD (Auditoria)' }
            ]
          },
          {
            name: 'DEC (Departamento de Educação e Cultura)',
            children: [
              { name: 'CMT (Colégio Militar Tiradentes)' },
              { name: 'CAEAp (Centro de Altos Estudos e Aperfeiçoamento)' },
              { name: 'DiForm (Diretoria de Formação)' },
              { name: 'DEEC (Diretoria de Especialização e Educação Continuada)' },
              { name: 'DPPHC (Diretoria de Pesquisa e Patrimônio Histórico e Cultural)' },
              { name: 'APMB (Academia de Polícia Militar)' },
              {
                name: 'DEA (Diretoria de Especialização e Aperfeiçoamento)',
                children: [
                  { name: 'CAP (Centro de Aperfeiçoamento)' },
                  { name: 'CTEsp (Centro de Treinamento e Especialização)' }
                ]
              }
            ]
          },
          {
            name: 'DGP (Departamento de Gestão de Pessoal)',
            expanded: true,
            children: [
              {
                name: 'DPM (Diretoria de Pessoal Militar)',
                expanded: false,
                children: [
                  { name: 'Administração Regional' },
                  { name: 'Secretaria de Estado de Esportes' },
                  { name: 'CGU' },
                  { name: 'Secretaria de Economia do DF' },
                  { name: 'SEMOB' },
                  { name: 'Ministério da Cidadania' },
                  { name: 'SERINS' },
                  { name: 'Ministério da Fazenda' },
                  { name: 'MPOG' },
                  { name: 'Casa Civil/GDF' },
                  { name: 'Secretaria da Criança' },
                  { name: 'Secretaria de Ciência, Tecnologia e Inovação' },
                  { name: 'Secretaria de Saúde' },
                  { name: 'Secretaria de Turismo' },
                  { name: 'TJDFT' },
                  { name: 'FNSP' },
                  { name: 'CM-GDF (Casa Militar)' },
                  { name: 'GSI/PR' },
                  { name: 'VGDF' },
                  { name: 'SSP-DF' },
                  { name: 'GSI/VPR' },
                  { name: 'CLDF' },
                  { name: 'MJ' },
                  { name: 'GOV AMAPÁ' },
                  { name: 'STF' },
                  { name: 'TSE' },
                  { name: 'TST' },
                  { name: 'MPDFT' },
                  { name: 'MPF' },
                  { name: 'Senado Federal' },
                  { name: 'Câmara dos Deputados' },
                  { name: 'MP (Missão de Paz)' },
                  { name: 'STJ' },
                  { name: 'STM' },
                  { name: 'ONU' },
                  { name: 'GSI/ABIN' },
                  { name: 'Ministério da Economia' },
                  { name: 'MDASCF' },
                  { name: 'OUTR ORGÃO' },
                  { name: 'DIV DESTIN' },
                  { name: 'DPM/Aguarda RR' },
                  {
                    name: 'SCAF (Seção de Controle de Afastamentos)',
                    expanded: true,
                    active: true,
                    children: [
                      { name: 'DPM/SCAF-Afast Jud' },
                      { name: 'DPM/SCAF-Cursos + 180 Dias' },
                      { name: 'DPM/SCAF-LTIP' },
                      { name: 'DPM/SCAF-LTSP +1 ano' },
                      { name: 'DPM/SCAF-LTSPF' },
                      { name: 'DPM/SCAF-Preso' },
                      { name: 'DPM/SCAF-Cursos Certame' },
                      { name: 'DPM/SCAF-Cargo Eletivo' },
                      { name: 'DPM/SCAF-CAEP' },
                      { name: 'DPM/SCAF-CAP' }
                    ]
                  }
                ]
              },
              {
                name: 'DIPC (Diretoria de Inativos, Pensionistas e Civis)',
                children: [
                  { name: 'DESLIGADO' }
                ]
              },
              {
                name: 'DVPC (Diretoria de Veteranos, Pensionistas e Civis)',
                children: [
                  { name: 'INATIVOS' }
                ]
              },
              { name: 'DPP (Diretoria de Pagamento de Pessoal)' }
            ]
          },
          {
            name: 'DLF (Departamento de Logística e Finanças)',
            children: [
              {
                name: 'DPTS (Diretoria de Patrimônio, Transporte e Suprimento)',
                children: [
                  { name: 'CMan (Centro de Manutenção)' }
                ]
              },
              { name: 'Pref (Prefeitura)' },
              { name: 'DALF (Diretoria de Apoio Logístico e Finanças)' },
              {
                name: 'DPMT (Diretoria de Patrimônio, Manutenção e Transporte)',
                children: [
                  { name: 'SAV (Seção de Alienação de Veículos)' }
                ]
              },
              { name: 'DiTel (Diretoria de Telemática)' },
              { name: 'DINFRA (Diretoria de Infraestrutura)' },
              { name: 'CMBel (Centro de Material Bélico)' }
            ]
          },
          {
            name: 'DOP (Departamento de Operações)',
            children: [
              { name: 'SO (Subchefia de Operações)' },
              { name: 'SOP (Subchefia de Ordem Pública)' },
              { name: 'COPOM (Centro de Operações da Polícia Militar)' },
              { name: 'CPSP (Centro de Políticas de Segurança Pública)' },
              { name: 'SEOPS (Secretaria Especial da Ordem Pública e Social)' },
              {
                name: 'CPME (Comando de Policiamento de Missões Especiais)',
                children: [
                  { name: 'BPCHOQUE (Batalhão de Policiamento de Choque)' },
                  { name: 'CMedVet (Centro de Medicina Veterinária)' },
                  { name: 'ROTAM (Batalhão de Policiamento Tático Motorizado)' },
                  { name: 'BPCães (Batalhão de Policiamento com Cães)' },
                  { name: 'BOPE (Batalhão de Operações Especiais)' },
                  { name: 'RPMON (Regimento de Polícia Montada)' },
                  { name: 'BAVop (Batalhão de Aviação Operacional)' }
                ]
              },
              { name: 'CME (Comando de Missões Especiais)' },
              { name: 'CPRM (Comando de Policiamento Regional Metropolitano)' },
              { name: 'CPRL (Comando de Policiamento Regional Leste)' },
              { name: 'CPRO (Comando de Policiamento Regional Oeste)' },
              { name: 'CPRS (Comando de Policiamento Regional Sul)' },
              { name: 'II CPRL (II Comando de Policiamento Regional Leste)' },
              { name: 'II CPRS (II Comando de Policiamento Regional Sul)' },
              {
                name: '1º CPR',
                children: [
                  { name: '1º BPM' }, { name: '3º BPM' }, { name: '5º BPM' }, { name: '6º BPM' }, { name: '7º BPM' }, { name: '24º BPM' }
                ]
              },
              {
                name: '2º CPR',
                children: [
                  { name: '4º BPM' }, { name: '15º BPM' }, { name: '25º BPM' }, { name: '28º BPM' }
                ]
              },
              {
                name: '3º CPR',
                children: [
                  { name: '2º BPM' }, { name: '11º BPM' }, { name: '17º BPM' }
                ]
              },
              {
                name: '4º CPR',
                children: [
                  { name: '8º BPM' }, { name: '10º BPM' }, { name: '16º BPM' }
                ]
              },
              {
                name: '5º CPR',
                children: [
                  { name: '13º BPM' }, { name: '14º BPM' }, { name: '20º BPM' }, { name: '21º BPM' }
                ]
              },
              {
                name: '6º CPR',
                children: [
                  { name: '9º BPM' }, { name: '26º BPM' }, { name: '27º BPM' }
                ]
              },
              {
                name: 'CPESP (Comando de Policiamento Especializado)',
                children: [
                  { name: '12º BPM' }, { name: 'BPMA (Batalhão de Polícia Militar Ambiental)' }, { name: '19º BPM' }, { name: 'BPEsc (Batalhão de Policiamento Escolar)' }, { name: 'BPR (Batalhão de Policiamento Rural)' }
                ]
              },
              {
                name: 'CPTRAN (Comando de Policiamento de Trânsito)',
                children: [
                  { name: 'BPTran (Batalhão de Policiamento de Trânsito)' }, { name: 'BPRv (Batalhão de Policiamento Rodoviário)' }
                ]
              },
              { name: 'CPEsc (Comando de Policiamento Escolar)' },
              { name: 'CPAM (Comando de Policiamento Ambiental)' }
            ]
          }
        ]
      }
    ]
  }
];

export const PCF_MATRIX = [
  {
    unidade: 'SAF - DPM', total: 42,
    months: [
      { val: 28, pct: 66, status: 'ideal' }, { val: 30, pct: 71, status: 'ideal' }, { val: 32, pct: 76, status: 'ideal' },
      { val: 35, pct: 83, status: 'warning' }, { val: 36, pct: 86, status: 'warning' }, { val: 34, pct: 81, status: 'warning' },
      { val: 29, pct: 69, status: 'ideal' }, { val: 26, pct: 62, status: 'ideal' }, { val: 27, pct: 64, status: 'ideal' },
      { val: 30, pct: 71, status: 'ideal' }, { val: 28, pct: 67, status: 'ideal' }, { val: 25, pct: 60, status: 'ideal' }
    ]
  },
  {
    unidade: 'SECAD - DPM', total: 18,
    months: [
      { val: 12, pct: 67, status: 'ideal' }, { val: 13, pct: 72, status: 'ideal' }, { val: 14, pct: 78, status: 'ideal' },
      { val: 15, pct: 83, status: 'warning' }, { val: 15, pct: 83, status: 'warning' }, { val: 14, pct: 78, status: 'ideal' },
      { val: 12, pct: 67, status: 'ideal' }, { val: 10, pct: 56, status: 'low' }, { val: 11, pct: 61, status: 'ideal' },
      { val: 12, pct: 67, status: 'ideal' }, { val: 11, pct: 61, status: 'ideal' }, { val: 10, pct: 56, status: 'low' }
    ]
  },
  {
    unidade: 'SMOV - DPM', total: 15,
    months: [
      { val: 10, pct: 67, status: 'ideal' }, { val: 10, pct: 67, status: 'ideal' }, { val: 11, pct: 73, status: 'ideal' },
      { val: 12, pct: 80, status: 'ideal' }, { val: 13, pct: 87, status: 'warning' }, { val: 12, pct: 80, status: 'ideal' },
      { val: 10, pct: 67, status: 'ideal' }, { val: 9, pct: 60, status: 'ideal' }, { val: 9, pct: 60, status: 'ideal' },
      { val: 10, pct: 67, status: 'ideal' }, { val: 9, pct: 60, status: 'ideal' }, { val: 8, pct: 53, status: 'low' }
    ]
  },
  {
    unidade: 'SPAG - DPM', total: 17,
    months: [
      { val: 6, pct: 67, status: 'ideal' }, { val: 7, pct: 78, status: 'ideal' }, { val: 7, pct: 78, status: 'ideal' },
      { val: 8, pct: 89, status: 'warning' }, { val: 8, pct: 89, status: 'warning' }, { val: 8, pct: 89, status: 'warning' },
      { val: 7, pct: 78, status: 'ideal' }, { val: 7, pct: 78, status: 'ideal' }, { val: 7, pct: 78, status: 'ideal' },
      { val: 8, pct: 89, status: 'warning' }, { val: 8, pct: 89, status: 'warning' }, { val: 7, pct: 78, status: 'ideal' }
    ]
  },
  {
    unidade: 'Outras Unidades', total: 13250,
    months: [
      { val: 872, pct: 63, status: 'ideal' }, { val: 945, pct: 68, status: 'ideal' }, { val: 1023, pct: 73, status: 'ideal' },
      { val: 1105, pct: 79, status: 'ideal' }, { val: 1198, pct: 86, status: 'warning' }, { val: 1087, pct: 78, status: 'ideal' },
      { val: 912, pct: 65, status: 'ideal' }, { val: 845, pct: 60, status: 'ideal' }, { val: 876, pct: 63, status: 'ideal' },
      { val: 1023, pct: 73, status: 'ideal' }, { val: 945, pct: 68, status: 'ideal' }, { val: 812, pct: 59, status: 'low' }
    ]
  }
];

export const PCF_CONFLITOS = [
  { date: '15/Abr/2025', desc: 'DPM - Excede limite Operacional', sub: 'O limite definido é de 10%, foi atingido 12%.' },
  { date: '20/Mai/2025', desc: 'BOPE - Baixo efetivo', sub: 'Efetivo cai abaixo do mínimo de segurança exigido.' }
];

export const CALENDARIO_KPIS = {
  totalFerias: { value: 2458, sub: 'PM em gozo' },
  emGozo: { value: 1987, sub: '80,9%' },
  programadas: { value: 371, sub: '15,1%' },
  reprogramadas: { value: 62, sub: '2,5%' },
  suspensas: { value: 38, sub: '1,5%' },
  conflitos: { value: 14, sub: '0,6%' }
};

export const CALENDARIO_EVENTOS = [
  { dia: 1, nome: 'Cap. Bruno Almeida', unidade: 'CG', status: 'em_gozo' },
  { dia: 2, nome: '1º Ten. Camila Costa', unidade: 'DPM', status: 'em_gozo' },
  { dia: 5, nome: 'Maj. Rafael Santos', unidade: 'DGP', status: 'em_gozo' },
  { dia: 6, nome: '2º Ten. Lucas Martins', unidade: 'CPR I', status: 'em_gozo' },
  { dia: 7, nome: 'Subten. José Ferreira', unidade: 'DAL', status: 'programada' },
  { dia: 8, nome: 'Sgt. Mariana Lima', unidade: 'CPA', status: 'em_gozo' },
  { dia: 9, nome: 'Cb. Rodrigo Silva', unidade: 'CPR II', status: 'em_gozo' },
  { dia: 12, nome: 'Cap. Aline Souza', unidade: 'DE', status: 'reprogramada' },
  { dia: 13, nome: 'Maj. Thiago Pereira', unidade: 'CPE', status: 'em_gozo' },
  { dia: 14, nome: '1º Ten. Fernanda Dias', unidade: 'CPR V', status: 'em_gozo' },
  { dia: 15, nome: 'Sgt. André Gomes', unidade: 'CG', status: 'em_gozo' },
  { dia: 16, nome: 'Subten. Cláudio Rocha', unidade: 'DGP', status: 'programada' },
  { dia: 19, nome: '2º Ten. Juliana Mota', unidade: 'CPR III', status: 'em_gozo' },
  { dia: 20, nome: 'Cap. Felipe Andrade', unidade: 'DAL', status: 'em_gozo' },
  { dia: 21, nome: 'Maj. Luís Henrique', unidade: 'CPR IV', status: 'suspensa' },
  { dia: 22, nome: 'Sgt. Leonardo Alves', unidade: 'CPA', status: 'em_gozo' },
  { dia: 23, nome: 'Cb. Patrícia Nunes', unidade: 'CPR VI', status: 'cancelada' },
  { dia: 26, nome: '1º Ten. Gabriel Rocha', unidade: 'CPE', status: 'em_gozo' },
  { dia: 27, nome: 'Subten. Marcos Paulo', unidade: 'APM', status: 'programada' },
  { dia: 28, nome: 'Maj. Renata Oliveira', unidade: 'DPM', status: 'em_gozo' },
  { dia: 29, nome: 'Cap. Diego Martins', unidade: 'CG', status: 'em_gozo' },
  { dia: 30, nome: '2º Ten. Beatriz Lima', unidade: 'CPR I', status: 'em_gozo' },
];

export const AFASTAMENTO_TIPOS = [
  { id: '1', nome: 'Férias Regulamentares', grupoFuncional: 'FERIAS_BENEFICIOS', exigeHomologacao: false, homologacaoAutomatica: true, maxDias: 30, exigeDocumento: false, exigeCid: false, ativo: true },
  { id: '2', nome: 'Licença para Tratamento de Saúde (LTSP)', grupoFuncional: 'SAUDE_LICENCAS_MEDICAS', exigeHomologacao: true, homologacaoAutomatica: false, maxDias: 365, exigeDocumento: true, exigeCid: true, ativo: true },
  { id: '3', nome: 'Abono de Ponto', grupoFuncional: 'FERIAS_BENEFICIOS', exigeHomologacao: true, homologacaoAutomatica: false, maxDias: 5, exigeDocumento: false, exigeCid: false, ativo: true },
  { id: '4', nome: 'Licença Especial (LE)', grupoFuncional: 'LICENCAS_PESSOAIS_EVENTOS_VIDA', exigeHomologacao: true, homologacaoAutomatica: false, maxDias: 180, exigeDocumento: true, exigeCid: false, ativo: true }
];

export const AFASTAMENTOS_LISTA = [
  {
    id: 'a1',
    matricula: '192837',
    nomeServidor: 'Alexandre Barbosa',
    tipoAfastamento: AFASTAMENTO_TIPOS[0],
    dataInicio: '2026-01-01',
    dataFim: '2026-01-30',
    status: 'APROVADO' as any,
    criadoEm: '2026-05-25T09:00:00Z',
  },
  {
    id: 'a2',
    matricula: '827364',
    nomeServidor: 'Renata Souza',
    tipoAfastamento: AFASTAMENTO_TIPOS[3],
    dataInicio: '2026-04-10',
    dataFim: '2026-05-10',
    status: 'PENDENTE' as any,
    criadoEm: '2026-05-25T09:00:00Z',
  },
  {
    id: 'a3',
    matricula: '473829',
    nomeServidor: 'Marcos Lima',
    tipoAfastamento: AFASTAMENTO_TIPOS[1],
    dataInicio: '2026-02-15',
    dataFim: '2026-02-20',
    status: 'APROVADO' as any,
    criadoEm: '2026-05-25T09:00:00Z',
  }
];

export const AFASTAMENTO_PARAMETROS = [
  { 
    chave: 'LIMIT_DIAS_UPM', 
    valor: '3', 
    descricao: 'Quantidade máxima de dias de atestado médico que a UPM pode homologar sem perícia central.',
    ultimaAlteracao: '2026-05-25T09:00:00Z',
    alteradoPor: 'DPM/SCAF'
  }
];

export interface AfastamentoSearchItem {
  type: string;
  pm: string;
  matricula: string;
  ref: string;
  details: string;
  status: string;
}

export const AFASTAMENTO_SEARCH_FIXTURE: AfastamentoSearchItem[] = [
  { type: 'Férias', pm: 'Subtenente PM Roberto Costa', matricula: '728.192-3', ref: 'Proc. 00192-000213/2026', details: 'Férias Homologadas (10/06 a 09/07)', status: 'Homologado' },
  { type: 'LTSP', pm: 'Cabo PM Aline Moreira', matricula: '921.034-5', ref: 'Atestado DPM-9812', details: 'Licença Saúde de 15 dias por recomendação médica', status: 'Ativo' },
  { type: 'Abono Natalício', pm: 'Sargento PM Marcos Souza', matricula: '812.384-9', ref: 'Aniversário 07/06', details: 'Abono Natalício concedido', status: 'Agendado' },
  { type: 'Licença Especial', pm: 'Major PM Cláudio Valente', matricula: '603.921-2', ref: 'Proc. 00192-000104/2025', details: '1º Decênio - Gozo de 30 dias', status: 'Em Gozo' },
  { type: 'Publicação', pm: 'Soldado PM Felipe Neves', matricula: '934.112-0', ref: 'BG nº 105/2026', details: 'Publicação de Dispensa Recompensa por mérito', status: 'Publicado' },
];

export const AFASTAMENTO_OPERATIONAL_LOGS_FIXTURE = [
  { time: '10:45', action: 'Abono Natalício concedido', target: 'Sd PM Lucas Ramos (Mat. 741.092-1)', badge: 'Abono' },
  { time: '10:30', action: 'Férias homologadas (15 dias)', target: 'Cap PM Juliana Silveira (Mat. 638.112-9)', badge: 'Férias' },
  { time: '09:15', action: 'Minuta de Portaria gerada', target: 'Dispensa Recompensa - Ten PM Marcelo Cruz', badge: 'Publicação' },
  { time: 'Ontem', action: 'LTSP registrada (8 dias)', target: 'Sgt PM Thiago Souza (Mat. 819.043-4)', badge: 'Saúde' },
  { time: 'Ontem', action: 'Retorno de Licença Especial', target: 'Maj PM Gabriel Almeida (Mat. 504.982-1)', badge: 'Licença' },
];

